import { format } from "date-fns";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import { getName } from "country-list";
import { getMatches, deleteMatch } from "../../services/match.service";
import CustomTable from "../../components/CustomTable";
import { IconButton, Button, Box } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { StyledTableCell } from "../../components/styled";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DATE_TIME_FORMAT, MatchStatus } from "../../utils/constants";
import { MatchImportDialog } from "../../components/MatchImportDialog";

const Matches = () => {
  const queryClient = useQueryClient();
  const [isImportOpen, setIsImportOpen] = useState(false);
  const [sortOrder, setSortOrder] = useState("DESC");

  const toggleSortOrder = () => {
    setSortOrder((prev) => (prev === "DESC" ? "ASC" : "DESC"));
  };

  const renderHeader = () => (
    <TableRow>
      <StyledTableCell>Round</StyledTableCell>
      <StyledTableCell>Status</StyledTableCell>
      <StyledTableCell>League</StyledTableCell>
      <StyledTableCell>Home Team</StyledTableCell>
      <StyledTableCell>Away Team</StyledTableCell>
      <StyledTableCell>Home Country</StyledTableCell>
      <StyledTableCell>Away Country</StyledTableCell>
      <StyledTableCell>
        <TableSortLabel
          active
          direction={sortOrder === "ASC" ? "asc" : "desc"}
          onClick={toggleSortOrder}
        >
          Start At
        </TableSortLabel>
      </StyledTableCell>
      <StyledTableCell>Action</StyledTableCell>
    </TableRow>
  );

  const { mutate: handleDelete } = useMutation({
    mutationFn: (id) => deleteMatch(id),
    onSuccess: () => {
      alert("Match deleted successfully");
      queryClient.invalidateQueries(["matches"]);
    },
    onError: (error) => {
      alert(`Error deleting match: ${error}`);
    },
  });

  const onDeleteClick = (match) => {
    if (window.confirm(`Are you sure you want to delete match ${match.id}?`)) {
      handleDelete(match.id);
    }
  };

  const renderRow = (match) => (
    <TableRow key={match.id}>
      <TableCell>{match.round || "N/A"}</TableCell>
      <TableCell>{match.status}</TableCell>
      <TableCell>{match.league?.name || "N/A"}</TableCell>
      <TableCell>{match.homeTeam?.name || "N/A"}</TableCell>
      <TableCell>{match.awayTeam?.name || "N/A"}</TableCell>
      <TableCell>
        {match.homeCountry ? getName(match.homeCountry.toLowerCase()) : "N/A"}
      </TableCell>
      <TableCell>
        {match.awayCountry ? getName(match.awayCountry.toLowerCase()) : "N/A"}
      </TableCell>
      <TableCell>
        {match.startAt
          ? format(new Date(match.startAt), DATE_TIME_FORMAT)
          : "N/A"}
      </TableCell>
      <TableCell>
        <IconButton aria-label="view" component={Link} to={`${match.id}`}>
          <VisibilityIcon />
        </IconButton>
        <IconButton
          aria-label="delete"
          color="error"
          onClick={() => onDeleteClick(match)}
        >
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="outlined"
          startIcon={<UploadFileIcon />}
          onClick={() => setIsImportOpen(true)}
          sx={{ mr: 1 }}
        >
          Import CSV
        </Button>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          component={Link}
          to="/matches/create"
        >
          Create Match
        </Button>
      </Box>

      <MatchImportDialog
        open={isImportOpen}
        onClose={() => setIsImportOpen(false)}
      />

      <CustomTable
        name={"matches"}
        getItemsMethod={getMatches}
        renderHeader={renderHeader}
        renderRow={renderRow}
        columnCount={9}
        filters={{
          status: {
            type: "select",
            label: "Status",
            options: [
              { value: MatchStatus.UPCOMING, label: "Upcoming" },
              { value: MatchStatus.LIVE, label: "Live" },
              { value: MatchStatus.FINISHED, label: "Finished" },
            ],
          },
        }}
        queryKeyParts={[sortOrder]}
        queryParams={{ sortOrder }}
        pageResetKey={sortOrder}
      />
    </>
  );
};

export default Matches;
